export const ru = {
    'not-found-description': 'Страница не найдена',
}
